import type { AeropayUser } from '@iheartjane/data-access';

import { getJwt } from '@jane/shared/auth';
import { createUseQueryHook, janeApi } from '@jane/shared/data-access';

import { queryKeys, urls } from './aeropay.util';

const fetchAeropayUser = async () => {
  const jwt = getJwt();

  if (jwt) {
    return await janeApi.get<AeropayUser>(urls.aeropayAccounts, jwt);
  } else {
    return null;
  }
};

interface UseAeropayUserProps {
  janeUserId?: string | number;
}

const enableUserQuery = ({ janeUserId }: UseAeropayUserProps) => {
  const jwt = getJwt();
  return !!jwt && !!janeUserId;
};

export const useKioskAeropayUser = createUseQueryHook<
  UseAeropayUserProps,
  AeropayUser | null
>(fetchAeropayUser, queryKeys.aeropayUser, enableUserQuery);
